export default "<p>welcome works!</p>\n<button mat-fab class=\"mc-add-button\" aria-label=\"Load a Memory Card\">\n    <mat-icon>addition</mat-icon>\n</button>"